import React, { useEffect, useState } from 'react';
import { mdiFilterOutline, mdiTrashCanOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { useNinjaTable } from 'components/tables/NinjaTable/useNinjaTable';
import {
  useListFiltersQuery,
  useDeleteFilterMutation,
} from 'store/redux/apis/workspace/workspace.api';
import ninjaApi from 'store/redux/apis';
import { snackbar } from 'components/notifications/notifications';
import Ninja from '@ninja';
import { Button, Spin } from 'antd';

const SavedFilter = () => {
  const { filters, setFilters, savedFiltersParams, clearFilter } = useNinjaTable();
  const [getGetSavedFilterQuery] = ninjaApi.useLazyGetSavedFilterQuery();
  const { data: savedFilters = [], isLoading: lisLoading } =
    useListFiltersQuery(savedFiltersParams);
  const [deleteFilter, { isLoading }] = useDeleteFilterMutation();
  const [active, setActive] = useState(filters._filterId);

  useEffect(() => {
    setActive(filters._filterId);
  }, [filters._filterId]);

  const toggleFilter = async (id) => {
    clearFilter();

    let newFilters = {};
    if (id !== filters?._filterId) {
      const res = await getGetSavedFilterQuery({ filter_id: id }).unwrap();
      newFilters = { ...res.filters, _filterId: res.id };
    }
    setFilters(newFilters);
  };

  const deleteSavedFilter = async (filterId) => {
    await deleteFilter({ filter_id: filterId })
      .unwrap()
      .then(() => {
        snackbar.success('Saved filter successfully deleted');
      });
  };

  if (lisLoading) {
    return <Spin size='small' />;
  }

  return (
    <div className='w-full'>
      <div className='grid gap-2'>
        {Array.isArray(savedFilters?.data) && savedFilters?.data?.length > 0 ? (
          savedFilters?.data?.map((f, index) => (
            <div className='flex items-center justify-between gap-2' key={index}>
              <Button
                key={f.id}
                type={active === f.id ? 'primary' : 'dashed'}
                onClick={() => {
                  if (active === f.id) {
                    setActive(null);
                    clearFilter();
                  } else {
                    setActive(f.id);
                    toggleFilter(f.id);
                  }
                }}
                icon={<Icon path={mdiFilterOutline} size={0.6} />}
              >
                {f.name}
              </Button>
              <Button
                type='text'
                loading={isLoading}
                onClick={() => deleteSavedFilter(f.id)}
                icon={<Icon color={Ninja.colors.mediumBlue} path={mdiTrashCanOutline} />}
              />
            </div>
          ))
        ) : (
          <div className='text-center text-color-light text-sm font-normal'>
            No saved filters available
          </div>
        )}
      </div>
    </div>
  );
};
export default SavedFilter;
